var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tooltip" }, [
    _c(
      "div",
      {
        staticClass: "container-hint mg mg--b-3",
        class: { tooltipVisible: _vm.isHintVisible }
      },
      [
        _c("p", { staticClass: "white text-medium" }, [
          _vm._v(_vm._s(_vm.textInfo))
        ])
      ]
    ),
    _c(
      "div",
      { staticClass: "info-icon" },
      [
        _c("svgicon", {
          attrs: { icon: "Info", height: "19", width: "19", color: "#5F646C" },
          on: { mouseover: _vm.showHint, click: _vm.showHint }
        }),
        _c("div", {
          staticClass: "arrow",
          class: { showArrow: _vm.isHintVisible }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }